import { useEffect, useState } from "react";

export enum DeviceType {
  Android = "Android",
  iOS = "iOS",
  Other = "Other",
}

export const getDeviceType = () => {
  const userAgent = typeof navigator === "undefined" ? "SSR" : navigator.userAgent;

  const isIos = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  const isAndroid = Boolean(userAgent.match(/Android/i));

  if (isIos) {
    return DeviceType.iOS;
  }

  if (isAndroid) {
    return DeviceType.Android;
  }

  return DeviceType.Other;
};

export const useDeviceType = () => {
  const [device, setDevice] = useState(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      setDevice(getDeviceType());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return device;
};
